
// This is an auto generated file - do not edit!
// Swagger path: /api/Comment/{entityType}/{entityId}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    CommentQueryResult, SystemEntity, Comment, CommentCreate
} from '@wdx/clmi/clmi-swagger-gen';
import { PaginationOptions } from '@wdx/shared/infrastructure/api-service';

@Injectable({ providedIn: 'root' })
export class CommentEntitytypeEntityidApiService extends BaseApiService {
    
    get(entityType: SystemEntity, entityId: string, options = {}, paginationOptions?: PaginationOptions): Observable<CommentQueryResult> {
        return this._get<CommentQueryResult>(
            `/Comment/${entityType}/${entityId}`,
            options,
            paginationOptions
        );
    }

    post(entityType: SystemEntity, entityId: string, comment: CommentCreate, options = {}): Observable<Comment> {
        return this._post<Comment, CommentCreate>(
            `/Comment/${entityType}/${entityId}`,
            new CommentCreate(comment),
            options
        );
    }
}
